import React from 'react';
import classNames from 'classnames';
import { ChevronDownIcon, ChevronUpIcon } from 'components/icons';
import styles from './SectorKPIsTableHeading.module.css';

function SectorKPIsTableHeading({ className, style, children, sortable, toggleSort }) {
  return (
    <div
      role="columnheader"
      tabIndex="-1"
      className={classNames(styles.root, 'rt-th', className)}
      style={style}
      onClick={toggleSort}
    >
      {children}
      <div className={styles.sort}>
        <ChevronUpIcon className={classNames(styles.icon, styles.asc)} />
        <ChevronDownIcon className={classNames(styles.icon, styles.desc)} />
      </div>
    </div>
  );
}

export default SectorKPIsTableHeading;
